var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6866 2.27299C12.3012 1.909 11.6988 1.909 11.3134 2.27299L4 9.18007L4.00008 21C4.00008 21.5523 4.44779 22 5.00008 22H12.0001L12 14.749C12 13.0922 13.3431 11.749 15 11.749H16C17.6569 11.749 19 13.0922 19 14.749L19.0001 22C19.5524 22 20.0001 21.5523 20.0001 21L20 9.18007L12.6866 2.27299ZM22 11.1632L22.2929 11.4561C22.6834 11.8467 23.3166 11.8467 23.7071 11.4561C24.0976 11.0656 24.0976 10.4324 23.7071 10.0419C23.0346 9.36944 22.3781 8.67488 21.6866 8.02201L14.0599 0.81896C12.9037 -0.272988 11.0963 -0.272986 9.94013 0.818961L2.31338 8.02201C1.62199 8.67497 0.965377 9.36943 0.292893 10.0419C-0.0976311 10.4324 -0.0976311 11.0656 0.292893 11.4561C0.683417 11.8467 1.31658 11.8467 1.70711 11.4561L2 11.1632L2.00008 21C2.00008 22.6569 3.34322 24 5.00008 24H19.0001C20.6569 24 22.0001 22.6569 22.0001 21L22 11.1632ZM17.0001 22L17 14.749C17 14.1967 16.5523 13.749 16 13.749H15C14.4477 13.749 14 14.1967 14 14.749L14.0001 22H17.0001ZM5 14.749C5 13.0922 6.34315 11.749 8 11.749C9.65685 11.749 11 13.0922 11 14.749C11 16.4059 9.65685 17.749 8 17.749C6.34315 17.749 5 16.4059 5 14.749ZM8 13.749C7.44772 13.749 7 14.1967 7 14.749C7 15.3013 7.44772 15.749 8 15.749C8.55228 15.749 9 15.3013 9 14.749C9 14.1967 8.55228 13.749 8 13.749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.15c459592ff41a988ce707bcc26080d0.svg";
export { ForwardRef as ReactComponent };